var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRf3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_677",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_677",
    transform: "scale(0.0208333 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_677",
    width: 48,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAtCAQAAABCQyBJAAACiElEQVRYw7WXTWxMURTHX9v/mxmVohEmEizEwkI0Fs2sprEZK3ShCQ2LtqlEUBriWwSbWQgLnyMtJhFFYuGrTSPtvgtdVFIliIRFhSG68BEtz/+decbIzLzF/bhnc+aeO//fu/fce+57jmOgYS8mcSayyLHV0AuP9h3dtgBRHMIHgRy2NovobDwSxGZriEgEjwl4VQdrCHcFZohoNyWXcJeVZOMeAddNpHU9Rij1saT/BHtHNMW9KpyXdHq4VQJoY++krnxGxIeQLDOzfdozQIvIZ7yqstEHjGU15BPVGKdEfwX5RtlFrTrP30yB325DuVhdDBOMPktU6wDOUWK0QuyoLN4xvQzcp0RfhViHAKbRpQMYoMSFitG1eCuQq8rlAlf494GQ+BxkBZFWBbT7dT82L3RMn78RkFICROvxjX+/GTaGu8kvI++j9WpzOClL0BE6Zil+cky3EqB2ljyfh2thT4gbHDGhmoeFeCKIHO/inWjFJtpGrCzeOVjtj3CbFBFc5bP4EVTUfzaF3fGaAuIpe47onIglOIBhvMYXCk/hawC5W4j38FePY64ReLk4/Tjul3THbMNtir4J/D30n5sGpPw55N/w0EX/pWnAYtk7DfYACyQLjeLvovfCMd3wibJjWEdvOa+fg+YB22UOY469hiTSyidYo8Vq3SZsNWFuCp3YJtbmzhfxeA1L8HRJZVG1X0X+pfyq3QkCOW37HAif4gfJxeBiwgbpOo25BhIczwP8pXETfwEP6Qwa2kFlAe/odNoE5OhssQkY9l+UbAL8qjeDFmsAnoJR6R5Hv7YNBdu0GWuwo/D+xLeEQWPH7H/LBlPjZ1ES+/nlZcLSvO57xTJY5Th/AL0Qq+PG7E4IAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf3);
export default __webpack_public_path__ + "static/media/rf3.df4162c7d751d06b698161c8db113a38.svg";
export { ForwardRef as ReactComponent };